export interface HeroSlide {
  id: string;
  tag: string;
  title: string;
  subtitle: string;
  cover: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "movie-interstellar-dawn",
    tag: "本周焦点 · 电影",
    title: "星际迷航：新纪元",
    subtitle:
      "人类首支跨星系远航船队启程，在未知星域面对文明存亡的抉择。宏大视效与人性拷问交织的年度科幻巨制。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%2C%20lone%20spaceship%20silhouette%20against%20a%20giant%20glowing%20planet%2C%20deep%20navy%20blue%20nebula%20and%20warm%20amber%20light%2C%20dramatic%20volumetric%20rays%2C%20dark%20moody%20atmosphere%20for%20text%20overlay%2C%20premium%20editorial%20rendering%2C%20no%20text&width=1920&height=1000&seq=hero-slide-01&orientation=landscape",
  },
  {
    id: "tv-changan-night",
    tag: "热播剧集 · 电视剧",
    title: "长安夜未央",
    subtitle:
      "一桩悬案揭开盛唐长安城表象之下的权力暗流。服化道考究，群像塑造细腻，本周讨论度最高的古装剧。",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20tiled%20rooftops%2C%20deep%20indigo%20sky%20with%20warm%20gold%20glow%2C%20atmospheric%20fog%2C%20dark%20moody%20cinematic%20scene%20for%20text%20overlay%2C%20premium%20editorial%20rendering%2C%20no%20text&width=1920&height=1000&seq=hero-slide-02&orientation=landscape",
  },
  {
    id: "variety-happy-journey",
    tag: "下饭综艺 · 综艺",
    title: "快乐出发吧",
    subtitle:
      "六位嘉宾自驾穿越山海，在真实旅途中完成任务挑战。笑点与温情并存的年度治愈系旅行综艺。",
    cover:
      "https://readdy.ai/api/search-image?query=Sunny%20coastal%20highway%20road%20trip%20at%20golden%20hour%2C%20convertible%20car%20silhouette%2C%20warm%20orange%20and%20soft%20cream%20sky%2C%20joyful%20summer%20atmosphere%2C%20cinematic%20wide%20scene%20for%20text%20overlay%2C%20no%20text&width=1920&height=1000&seq=hero-slide-03&orientation=landscape",
  },
];